var _rect, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLiveChatWebchat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    rx: 2,
    fill: "#9DA3E2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.311 7.763c.544-.23.974-.542 1.288-.937.315-.395.472-.825.472-1.29 0-.466-.157-.896-.472-1.291-.314-.395-.744-.708-1.288-.937a4.524 4.524 0 00-1.775-.344c-.64 0-1.232.115-1.776.344-.544.23-.973.542-1.288.937C2.157 4.64 2 5.07 2 5.535c0 .399.119.774.357 1.126.237.351.564.648.979.889-.033.08-.068.154-.103.22a1.273 1.273 0 01-.125.194c-.049.062-.087.11-.113.146-.027.035-.07.084-.131.148a3.54 3.54 0 00-.158.173c-.002-.002-.009.007-.02.025l-.018.028-.013.025a.107.107 0 00-.01.03.196.196 0 00-.002.032c0 .012.002.023.005.033a.166.166 0 00.058.105c.031.027.066.04.103.04h.015c.167-.023.311-.05.432-.08a4.223 4.223 0 001.396-.643c.301.054.596.08.884.08a4.52 4.52 0 001.775-.343z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.643 7.949c.238-.35.357-.726.357-1.128 0-.412-.126-.797-.377-1.155A2.977 2.977 0 009.6 4.772a2.592 2.592 0 01-.221 2.039 3.362 3.362 0 01-.965 1.065c-.388.28-.83.497-1.326.648a5.306 5.306 0 01-1.993.206c.673.441 1.463.662 2.37.662.288 0 .583-.026.884-.08.415.295.88.509 1.396.643.12.03.265.057.432.08a.152.152 0 00.11-.035.186.186 0 00.066-.11c-.002-.02 0-.031.005-.033.005-.001.004-.012-.002-.032l-.01-.03-.013-.026a.233.233 0 00-.038-.052.642.642 0 01-.042-.048 3.498 3.498 0 00-.116-.126 1.974 1.974 0 01-.13-.148 15.573 15.573 0 00-.113-.145 1.27 1.27 0 01-.126-.194 2.767 2.767 0 01-.103-.22c.415-.242.742-.537.98-.887z",
    fill: "#fff"
  })));
}

export default __webpack_public_path__ + "./fonts/live-chat-webchat.6f07f397fd96448baca1714446df6d6e.svg";
export { SvgLiveChatWebchat as ReactComponent };